/**
 * Legacy /reels/:token → redirect to unified reels share URL /reels?t=
 * Secret + multi-use share links both resolve on /reels via access dual-lookup.
 */
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function ReelInviteViewer() {
  const { token: tokenParam } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const token = (tokenParam || "").trim().toLowerCase();

  useEffect(() => {
    if (!token) {
      navigate("/reels", { replace: true });
      return;
    }
    navigate(`/reels?t=${encodeURIComponent(token)}`, { replace: true });
  }, [token, navigate]);

  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-black">
      <Loader2 className="h-8 w-8 animate-spin text-white/40" />
    </div>
  );
}
